import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCreateNewAccountModal,
  selectForgottenPasswordModal,
  setCreateNewAccountModal,
  setForgottenPasswordModal,
} from "slices/signInPageSlice";
import Modal from "components/HOCS/Modal";
import CreateNewAccountForm from "components/SignIn/CreateNewAccount/CreateNewAccountForm";
import ForgotPasswordForm from "components/SignIn/ForgotPassword/ForgotPasswordForm";
import SignInForm from "components/SignIn/SignIn/SignInForm";
import JoiningEfficeDeets from "../ui/JoiningEfficeDeets";
import GuestForm from "./GuestForm/GuestForm";

const JoinSignIn = ({ inviteEffice, isRoot, postConfirm }) => {
  const dispatch = useDispatch();
  const createNewAccountModal = useSelector(selectCreateNewAccountModal);
  const forgottenPasswordModal = useSelector(selectForgottenPasswordModal);
  const [withAccount, setWithAccount] = useState(false);

  // if there is a current user, it means they need to go to sign In page,
  // if not it means they jumped straigt into the app with this route (possibly by a bookmark), in which we should send them to home page which will check for auth and redirect if necessary
  return (
    <>
      {createNewAccountModal && (
        <Modal
          onDismiss={() => dispatch(setCreateNewAccountModal(false))}
          lightBackDrop={true}
          growth={true}
          header={<div>Sign Up</div>}
          content={<CreateNewAccountForm postCreate={postConfirm} />}
          actions={null}
          noBackDropClick={true}
          containerClass={"signInUpFormBox"}
        ></Modal>
      )}
      {forgottenPasswordModal && (
        <Modal
          onDismiss={() => {
            dispatch(setForgottenPasswordModal(false));
          }}
          lightBackDrop={true}
          growth={false}
          header={<div>Password Reset</div>}
          content={<ForgotPasswordForm postSignIn={postConfirm} />}
          actions={null}
          noBackDropClick={true}
          containerClass={"signInUpFormBox"}
        ></Modal>
      )}
      <div className="col-lg-6 col-sm-12 text-center">
        <JoiningEfficeDeets inviteEffice={inviteEffice} />
      </div>
      <div className="col-lg-6 col-sm-12">
        {withAccount ? (
          <>
            <button
              onClick={() => dispatch(setCreateNewAccountModal(true))}
              className="confirm-button growth-button mt-1 new-account-button form-shadow"
            >
              Make An Account
            </button>
            <div className="signInUpFormBox form-shadow">
              <SignInForm postSignIn={postConfirm} />
              <button
                onClick={() => {
                  dispatch(setForgottenPasswordModal(true));
                }}
                className="forgotten-password"
              >
                forgot password?
              </button>
            </div>
          </>
        ) : (
          <button
            onClick={() => setWithAccount(true)}
            className="confirm-button new-account-button guest-button growth-button form-shadow"
          >
            Sign Up / Log In
          </button>
        )}
        {!isRoot && (
          <>
            {withAccount ? (
              <button
                onClick={() => setWithAccount(false)}
                className="confirm-button new-account-button guest-button form-shadow"
              >
                Join Without An Account
              </button>
            ) : (
              <>
                <div className="or-line">OR</div>
                <div className="signInUpFormBox form-shadow">
                  <GuestForm onSubmit={postConfirm} />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default JoinSignIn;
